import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_TRAVEL_REQUESTS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_TRAVEL_REQUEST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_TRAVEL_REQUEST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_TRAVEL_REQUEST:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_TRAVEL_REQUEST:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
